import { ReactNode } from 'react';
import { Box, FormControlLabel, Switch, SxProps, Theme, Typography } from '@mui/material';

interface SidebarSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: ReactNode;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

function SidebarSwitch({ checked, onChange, label, disabled = false, sx }: SidebarSwitchProps) {
  return (
    <Box sx={sx}>
      <FormControlLabel
        control={
          <Switch
            checked={checked}
            disabled={disabled}
            onChange={e => onChange(e.target.checked)}
            sx={{
              '& .MuiSwitch-switchBase.Mui-checked': { color: 'primary.main' },
              '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: 'primary.main' },
            }}
          />
        }
        label={<Typography variant="body2">{label}</Typography>}
      />
    </Box>
  );
}

export default SidebarSwitch;
